import axios from '@/lib/axios';
import { CommentAttachment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2151. コメント添付ファイル登録
 * [POST] /workspaces/:identifier/comment_attachments
 */
type Props = {
  identifier: string;
  file: string;
  file_name: string;
  mime_type: string;
};

const createCommentAttachment = (props: Props): Promise<CommentAttachment> => {
  return axios.post(`/api/workspaces/${props.identifier}/comment_attachments`, props);
};

export const useCreateCommentAttachment = () => {
  return useMutation({
    mutationFn: createCommentAttachment,
  });
};
